import React from 'react';
import { Route } from 'react-router-dom';
import { View } from '../../../../../components';
import { applet, view } from './core';

// import ConfirmEmail from './ConfirmEmail';
const ConfirmEmail = React.lazy(() => import('./ConfirmEmail'));

export default (<Route exact key={view} path={view}>
  <View view={view} applet={applet} component={ConfirmEmail} />
</Route>);
